/**
 * Created by filatov on 13.05.2015.
 */

function FeatureDiffStateController(){}

FeatureDiffStateController.prototype.init = function(oldEnabledFeatures, newEnabledFeatures){
    var diff = {
        addedFeatures: {},
        featuresChanged: false
    };

    diff.oldFeatures = {...oldEnabledFeatures}
    diff.newFeatures = {...newEnabledFeatures}

    for( var feature in newEnabledFeatures )
    {
        if( !oldEnabledFeatures.hasOwnProperty( feature ) )
        {
            diff.addedFeatures[feature] = true;
        }
        else
            delete oldEnabledFeatures[feature];
    }
    diff.deletedFeatures = oldEnabledFeatures;
    diff.validateFeaturesChanged = function(){
        this.featuresChanged = false;
        for( var f in this.addedFeatures )
        {
            this.featuresChanged = true;
        }
        for( var f in this.deletedFeatures )
        {
            this.featuresChanged = true;
        }
    };
    diff.validateFeaturesChanged();
    diff.isFeatureDeleted = function ( featureName ) { return this.deletedFeatures.hasOwnProperty( featureName ); };
    diff.wasFeatureAdded = function ( featureName ) { return this.addedFeatures.hasOwnProperty( featureName );};

    diff.areFeaturesChanged = function () {return this.featuresChanged;};
    diff.wasFeatureChanged = function ( featureName ) {return diff.isFeatureDeleted(featureName) || diff.wasFeatureAdded(featureName)};

    diff.wasFeatureEnabledBefore = feature => !!diff.oldFeatures[feature]
    diff.isFeatureEnabledAfter = feature => !!diff.newFeatures[feature]

    return diff;
};

export default FeatureDiffStateController



// WEBPACK FOOTER //
// ./web/js/FeaturesDiffStateController.js